import { defineStore } from 'pinia'

import type { LessonRoomStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useLessonRoomStore = defineStore('lesson-room', {
  state: (): LessonRoomStore => ({
    booking: null,
    lastLesson: false,
    activeOverlay: 'none',
    chatUnread: false,
    chatMessages: [],
    permissionsBlocked: false,
    deniedMic: false,
    deniedCam: false,
    guideCategory: null,
  }),
  actions,
  getters,
})